import { DatePipe } from "@angular/common";
import { Inject, LOCALE_ID, OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { Subject } from "rxjs";

@Pipe({
  name: "humanizeDate",
})
export class HumanizeDatePipe extends DatePipe implements PipeTransform,OnDestroy {
  private destroy$ = new Subject<void>();
  constructor(@Inject(LOCALE_ID) locale: string) {
    super(locale);
  }

  transform(value: Date | string | number, format?: string): string | null;
  transform(value: null | undefined, format?: string): null;
  transform(value: Date | string | number | null | undefined, format?: string): string | null;
  transform(value: Date | string | number | null | undefined, format?: string): string | null {
    const date = new Date().setHours(0,0,0,0);
    const passedDate = new Date(value).setHours(0,0,0,0);
    if (date === passedDate) {
      return 'Today ' + this.getTime(format, value);
    } else if (date - 86400000 === passedDate) {
      return 'Yesterday ' + this.getTime(format, value);
    } else {
      return super.transform(value, format);
    }
  }

  private getTime(format, value) {
    if (format && format.includes('hh:mm')) {
      return super.transform(value, 'hh:mm a');
    } else if (format && format.includes('h:mm')) {
      return super.transform(value, 'h:mm a');
    } else {
      return '';
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}


